import { IAderenciaChartProps } from '../..'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */

export interface IPanoramaProps{
  id?: string
  aderentes: IAderenciaChartProps
  naoAderentes: IAderenciaChartProps
  aderentesRessalva: IAderenciaChartProps
  resultadoEntregue: IAderenciaChartProps
  resultadoComputado: IAderenciaChartProps
  onChoiceAderencia: (index: number, serie: number) => void

}

export const PanoramaChart: React.FC<IPanoramaProps> = ({ id, aderentes, aderentesRessalva, naoAderentes, resultadoComputado, resultadoEntregue, onChoiceAderencia }) => {
  function GerarGrafico(): void {
    const series = [
      {
        name: 'Aderentes',
        data: [aderentes.aderentes, aderentesRessalva.aderentes, naoAderentes.aderentes]
        // data: [aderentes.aderentes, aderentesRessalva.aderentes, naoAderentes.aderentes, resultadoComputado.aderentes, resultadoEntregue.aderentes]
      },
      {
        name: 'Aderentes com ressalva',
        data: [aderentes.aderentesRessalva, aderentesRessalva.aderentesRessalva, naoAderentes.aderentesRessalva]
        // data: [aderentes.aderentesRessalva, aderentesRessalva.aderentesRessalva, naoAderentes.aderentesRessalva, resultadoComputado.aderentesRessalva, resultadoEntregue.aderentesRessalva]
      },
      {
        name: 'Não aderentes',
        data: [aderentes.naoAderentes, aderentesRessalva.naoAderentes, naoAderentes.naoAderentes]
        // data: [aderentes.naoAderentes, aderentesRessalva.naoAderentes, naoAderentes.naoAderentes, resultadoComputado.naoAderentes, resultadoEntregue.naoAderentes]
      }
    ]
    const options = {
      series: series,
      colors: ['#27AE60', '#FFBF2A', '#EB5757'],
      chart: {
        type: 'bar',
        stacked: true,
        height: 450,
        width: 450,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            onChoiceAderencia(opts.dataPointIndex as number, opts.seriesIndex as number)
          }
        }
      },
      plotOptions: {
        bar: {

          horizontal: false,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: '12px',
                fontWeight: 900
              }
            }
          }
        }
      },
      stroke: {
        width: 1,
        colors: ['#ccc']
      },
      title: {
        text: 'Panorama resultados'
      },
      xaxis: {
        categories: ['Aderentes', 'Ressalva', 'Não aderentes', 'Computado IA', 'Entregue']
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val: number, context: any) {
            const { dataPointIndex } = context

            // Somar todos os valores das séries para a posição da barra
            const total = series.reduce((acc, serie) => acc + serie.data[dataPointIndex], 0)
            const percent = (val / total) * 100

            return `${percent.toFixed(1)}%`
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        offsetY: 10
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [aderentes])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
